import React from 'react';

import ListPageHeader from '@shared/ListPageHeader';
import AccessibleIpAddressesList from '@shared/accessible_ip_addresses/AccessibleIpAddressesList';

import { accessibleIpAddressService } from '@services/operator/accessibleIpAddressService';

const OperatorAccessibleIpAddressesList: React.FC = () => {
  return (
    <div>
      <ListPageHeader items={['org_management', 'org_management.accessible_ips']} />
      <AccessibleIpAddressesList accessibleIpAddressService={accessibleIpAddressService} role="operator" />
    </div>
  );
};

export default OperatorAccessibleIpAddressesList;
